import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import InputForm from '../../InputForm';
import SelectForm from '../../SelectForm';
import InputMultiImage from '../../imagenes_multi_componente/InputMultiImage';

const FormCategoriaPlatillo = ({datos, handleChange, handleSave, handleChangeImagen, multiImagenes, estatus, error}) => {
    const navigate = useNavigate();
    // const [disabledButton, setDisabledButton] = useState(false)
    const goBack = () => {
        navigate(-1);
    };

    return (
        <div className="card h-100 p-0 radius-12 overflow-hidden">
            <div className="card-body p-40">
                <div className="row">
                    <InputForm
                        name="nombre"
                        label="Nombre Categoría"
                        datos={datos}
                        change={handleChange}
                        error={error}
                        required/>
                    {/* <InputForm
                        name="descripcion"
                        label="Descripción"
                        datos={datos}
                        change={handleChange}
                        error={error}
                        required/> */}
                    <InputMultiImage
                        label="Imagenes"
                        multiImagenes={multiImagenes}
                        handleChangeImagen={handleChangeImagen}
                        maxImages={1}
                        name="multiImagenes"
                        errores={error}
                    />
                    <SelectForm
                        name='estatus'
                        label='Estatus'
                        datos={datos}
                        change={handleChange}
                        options={estatus}
                    />
                    
                    {/* <div className="form-switch switch-primary d-flex align-items-center gap-2 mt-2 mx-3">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="switch1"
                            defaultChecked={true}
                        />
                        <label
                            className="form-check-label line-height-1 fw-medium text-secondary-light"
                            htmlFor="switch1"
                        >
                            Es visible?
                        </label>
                    </div> */}
                    <div className="d-flex align-items-center justify-content-between gap-3 mt-24">
                        <button
                            onClick={goBack}
                            type="reset"
                            className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                        >
                            Cancelar
                        </button>
                        <button
                            // type="submit"
                            // disabled={disabledButton}
                            onClick={
                                () => {
                                    // setDisabledButton(true);
                                    handleSave();
                                }
                            }
                            className="btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                        >
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default FormCategoriaPlatillo;